import { DATE_FORMAT } from '@/base/config'
export default (value, format = DATE_FORMAT) => {
    if (value === null) return
    const date = new Date(value)
    return date.toLocaleDateString(['en-US'], format) + ' ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
}